"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TakePhoto = void 0;
const __1 = require("..");
const icons_1 = require("../../icons");
const react_1 = __importStar(require("react"));
const fileUtils_1 = require("../utils/fileUtils");
const TakePhoto = ({ fullWidth, onChange, id, capture, }) => {
    const [photoTaken, setPhotoTaken] = (0, react_1.useState)(false);
    const handleChange = async (event) => {
        const file = (event.currentTarget?.files && event.currentTarget?.files[0]) ||
            (event.target?.files && event.target?.files?.[0]);
        if (file) {
            try {
                const imageUrl = URL.createObjectURL(file) || "#";
                const { filename, extension, encodedFile } = await (0, fileUtils_1.getFileData)(file);
                onChange({ encodedFile, filename, extension, imageUrl });
                setPhotoTaken(true);
            }
            catch (error) {
                throw new Error(error);
            }
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("input", { "data-testid": "file-input", onChange: handleChange, accept: "image/*", style: { display: 'none' }, id: id, type: "file", capture: capture }),
        react_1.default.createElement("label", { htmlFor: id, style: {
                cursor: 'pointer',
                textAlign: 'center',
                display: 'flex',
            } },
            react_1.default.createElement(__1.Box, { sx: {
                    display: 'flex',
                    width: fullWidth ? '100%' : undefined,
                } },
                react_1.default.createElement(__1.Box, { width: "100%", display: "flex" },
                    react_1.default.createElement(__1.Button, { variant: photoTaken ? 'outlined' : 'contained', component: __1.Box },
                        react_1.default.createElement(__1.Box, { display: "flex", alignItems: "center", gap: 1 },
                            react_1.default.createElement(icons_1.Camera, null),
                            photoTaken ? 'Retake Photo' : 'Take Photo')))))));
};
exports.TakePhoto = TakePhoto;
exports.default = exports.TakePhoto;
